interface FindingCountProps {
    count: number;
    componentCount: number;
    className?: string;
}

export default function FindingCount({count, componentCount, className}: FindingCountProps) {
    if (count === 0) {
        return null;
    }

    return <span className={className}>
        {count} {count === 1 ? 'finding' : 'findings'}
        {' in '}{componentCount} {componentCount === 1 ? 'component' : 'components'}
    </span>;
}
